import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let valuesSwiperWr = document.querySelectorAll('.values-swiper-wr');
valuesSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 14,
      slidesPerView: 1,
      speed: 500,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        452: {
          spaceBetween: 16,
          slidesPerView: 2,
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 3,
        },
        1024: {
          spaceBetween: 14,
          slidesPerView: 4,
        },
        1200: {
          spaceBetween: 17,
          slidesPerView: 4,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      }
    });
    swiperObserver(swiper);

    const valuesTitles = el.querySelectorAll('.value-card__title');
    const valuesTexts = el.querySelectorAll('.value-card__text');

    if(valuesTitles.length) {
      lineTitlesFunc(valuesTitles);
    }

    if(valuesTexts.length) {
      lineTitlesFunc(valuesTexts);
    }
  }
});